import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';
import type { AnalyticsParams, TestsResponse } from '../types';

interface IProps {
  orgId?: string;
  params: AnalyticsParams;
  enabled?: boolean;
}

const useTests = ({ orgId, params, enabled = true }: IProps) =>
  useQuery<TestsResponse>({
    queryKey: ['analytics', 'tests', orgId, params],
    queryFn: async () => {
      const { data } = await Api.GetTests(params);
      return data;
    },
    enabled: !!orgId && enabled,
    staleTime: 30_000,
  });

export default useTests;
